import { render } from "./VideoPlayerOverlay.vue?vue&type=template&id=2b0084da&ts=true"
import script from "./VideoPlayerOverlay.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerOverlay.vue?vue&type=script&lang=ts"

import "./VideoPlayerOverlay.vue?vue&type=style&index=0&id=2b0084da&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__